import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import RecordHistory from './models/history/recordHistory.model';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    editingEntity: null,
    sidebarActive: true,
    isMobile: window.innerWidth < 1088,
    status: "",
    usersExexLimets:[],
    token: localStorage.getItem("token") || "",
    user: JSON.parse(localStorage.getItem("user") || "{}") || {},
    defaultCountry: null,
    openAddRequesRoleModal: false,
    openTabInvestigator:false,
    updateRequestRoleTable: false,
    loading: true,
    showPendingEvaluations: true,
    isNationalInterest:false,
    showSidebar: true,
    refreshUserLoading: false,
    displayMoreEvaluatorsRequiredAlert: false,
    recordHistory: Array<RecordHistory>(),
    showFileInput: false
  },
  mutations: {
    set_token(state, token) {
      state.token = token;
    },
    setNationalInterest(state, isNationaInterest) {
      state.isNationalInterest = isNationaInterest;
    },
    set_user(state, user) {
      state.user = user;
    },
    set_userExedLimted(state,userExedLimits){
        state.usersExexLimets = userExedLimits;
    },
    setDefaultCountry(state, country) {
      state.defaultCountry = country;
    },
    setOpenAddRequesRoleModal(state, yesNo) {
      state.openAddRequesRoleModal = yesNo;
    },
    setopenTabInvestigator(state, yesNo) {
      state.openTabInvestigator = yesNo;
    },
    setUpdateRequestRoleTable(state, yesNo) {
      state.updateRequestRoleTable = yesNo;
    },
    setUserImage(state, image){
      state.user.profileImage = image;
    },
    set_loading(state, loading){
      state.loading = loading;
    },
    set_refreshUserLoading(state, loading) {
      state.refreshUserLoading = loading;
    },
    set_displayMoreEvaluatorsRequiredAlert(state, value) {
      state.displayMoreEvaluatorsRequiredAlert = value;
    },
    set_showSidebar(state, value){
      state.showSidebar = value;
    },
    set_showPendingEvaluations(state, data){
      state.showPendingEvaluations = data;
    }
  },
  actions: {
    getPendingEvaluations({ commit }, userId) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_API_URL + `Porposal/validatePendingEvaluationsByUserId/${userId}`,
          data: userId,
          method: "GET"
        })
          .then(resp => {
            commit('set_showPendingEvaluations', resp.data);
            resolve(resp);
          }).catch(err => {
            reject(err);
          });
      });
    },
    getAnnoucementNationalInterest({ commit }) {
      
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_API_URL + `Annoucements/GetAnnouncementNationalInterestIfExist`,
          method: "GET"
        })
          .then(resp => {
            commit('setNationalInterest', resp.data);
            resolve(resp);
          }).catch(err => {
            reject(err);
          });
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    isUserIn: state => !!state.user.id,
  }
});
